import { render } from "./PopularCategories.vue?vue&type=template&id=01077708&scoped=true"
import script from "./PopularCategories.vue?vue&type=script&lang=js"
export * from "./PopularCategories.vue?vue&type=script&lang=js"

import "./PopularCategories.vue?vue&type=style&index=0&id=01077708&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01077708"]])

export default __exports__